import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { SttTabs, SttFullDialog } from '../../../sporttia/all';
import { useQuery, useCrud } from '../../../lib/hooks';
import RestrictionDetails from './RestrictionDetails';
import RestrictionUsers from './RestrictionUsers';
import RestrictionGroups from './RestrictionGroups';
import { getPath } from '../../Pages';

type RestrictionType = {
    id?: string;
    name?: string;
    facilities?: unknown[];
    weekdays?: unknown;
    months?: unknown;
};

export default function Restriction(): React.ReactElement {
    const { id } = useParams<{ id: string }>();
    const { trash } = useQuery();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [restriction, setRestriction, , Get, ,] = useCrud<any>(undefined);
    const tabs = [
        {
            caption: t('Detail'),
            component: (
                <RestrictionDetails
                    id={id as any}
                    trash={trash as any}
                    restrictionInit={
                        (restriction as RestrictionType)?.facilities
                            ? restriction
                            : { ...restriction, facilities: [] }
                    }
                    weekdaysInit={
                        (restriction as RestrictionType)?.weekdays as any
                    }
                    monthsInit={(restriction as RestrictionType)?.months as any}
                />
            ),
        },
        {
            caption: t('Users'),
            component: <RestrictionUsers id={id} trash={trash as any} />,
            show: id !== 'create',
        },
        {
            caption: t('Groups'),
            component: <RestrictionGroups idRestriction={id} />,
            show: id !== 'create',
        },
    ];
    /**
     * Load restriction
     */
    function loadRestriction() {
        Get(`/bookings/restrictions/${id}`, {
            trash: trash as any,
        }).then((response: any) => {
            if (response.bookingRestriction) {
                setRestriction(response.bookingRestriction);
            }
        });
    }

    useEffect(() => {
        if (id && id !== 'create') {
            loadRestriction();
        }
    }, [id]);

    return (
        <SttFullDialog
            {...({
                open: !!(restriction?.id || id === 'create'),
                onClose: () => navigate(getPath('restrictions')),
                title: restriction ? restriction.name : t('CreateRestriction'),
            } as any)}
        >
            <SttTabs tabs={tabs as any} />
        </SttFullDialog>
    );
}
